module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/chatboard2-d69bcd8c75269013706653cf78a04015.gif";